module.exports = __webpack_public_path__ + "img/logo-f4.dad25f23.png";